export default class CheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: this.props.checked,
    };
  }
  toggleChange = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  }
  render() {
    return (
      <label className="checkbox" htmlFor={this.props.id}>
        <input type="checkbox"
          id={this.props.id}
          name={this.props.name}
          checked={this.state.isChecked}
          onChange={this.toggleChange}
        />
        {this.props.label}
       </label>
    );
  }
}

CheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.object,
  checked: PropTypes.bool
}
